import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";

// A shard serves this same bundle at /local/ as its own page (views/local),
// which has no Watchtower, tenant or sign-in of the console's kind.
const LocalApp = lazy(() => import("./views/local/LocalApp"));

const root = document.getElementById("root");
if (!root) throw new Error("no #root element");

const isLocal = window.location.pathname === "/local" || window.location.pathname.startsWith("/local/");

createRoot(root).render(
  <StrictMode>
    {isLocal ? (
      <Suspense fallback={null}>
        <LocalApp />
      </Suspense>
    ) : (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )}
  </StrictMode>,
);
